import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";

export default function ContactForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const validate = () => {
    const e = {};
    if (!values.name.trim()) e.name = t("home.contact.errors.name");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) e.email = t("home.contact.errors.email");
    if (!values.message.trim() || values.message.trim().length < 5) e.message = t("home.contact.errors.message");
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    // Frontend-only. Redirect to thank-you.
    setTimeout(() => navigate("/thank_you"), 400);
  };

  return (
    <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4" data-testid="contact-form" noValidate>
      <div>
        <label className="block text-sm mb-1 text-[color:var(--rv-ink)]">{t("home.contact.form.name")}</label>
        <input
          type="text"
          value={values.name}
          onChange={(e) => setValues((v) => ({ ...v, name: e.target.value }))}
          placeholder={t("home.contact.form.namePlaceholder")}
          className="w-full rounded-lg border border-[color:var(--rv-line)] bg-white px-4 py-3 text-[color:var(--rv-ink)] focus:outline-none focus:ring-2 focus:ring-[color:var(--rv-ink)]/20"
          data-testid="contact-name"
        />
        {errors.name && <div className="text-xs text-red-600 mt-1">{errors.name}</div>}
      </div>
      <div>
        <label className="block text-sm mb-1 text-[color:var(--rv-ink)]">{t("home.contact.form.email")}</label>
        <input
          type="email"
          value={values.email}
          onChange={(e) => setValues((v) => ({ ...v, email: e.target.value }))}
          placeholder={t("home.contact.form.emailPlaceholder")}
          className="w-full rounded-lg border border-[color:var(--rv-line)] bg-white px-4 py-3 text-[color:var(--rv-ink)] focus:outline-none focus:ring-2 focus:ring-[color:var(--rv-ink)]/20"
          data-testid="contact-email"
        />
        {errors.email && <div className="text-xs text-red-600 mt-1">{errors.email}</div>}
      </div>
      <div>
        <label className="block text-sm mb-1 text-[color:var(--rv-ink)]">{t("home.contact.form.message")}</label>
        <textarea
          rows={4}
          value={values.message}
          onChange={(e) => setValues((v) => ({ ...v, message: e.target.value }))}
          placeholder={t("home.contact.form.messagePlaceholder")}
          className="w-full rounded-lg border border-[color:var(--rv-line)] bg-white px-4 py-3 text-[color:var(--rv-ink)] focus:outline-none focus:ring-2 focus:ring-[color:var(--rv-ink)]/20"
          data-testid="contact-message"
        />
        {errors.message && <div className="text-xs text-red-600 mt-1">{errors.message}</div>}
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <p className="text-xs text-[color:var(--rv-muted)]">{t("home.contact.form.consentNote")}</p>
        <button
          type="submit"
          disabled={submitting}
          className="inline-flex items-center justify-center rounded-full bg-[color:var(--rv-ink)] text-[color:var(--rv-bg)] px-6 py-3 text-sm font-semibold hover:opacity-90 disabled:opacity-60"
          data-testid="contact-submit"
        >
          {submitting ? t("home.contact.form.sending") : t("home.contact.form.submit")}
        </button>
      </div>
    </form>
  );
}
